// src/lib/inputQuality.js

const LOW_EFFORT_PHRASES = new Set([
  'idk', 'whatever', 'nothing', 'sure', 'ok', 'yes', 'no',
  'i don\'t know', 'stuff', 'things', 'idc', 'n/a', 'na', 'none',
])

const KEYBOARD_RUNS = ['asdf', 'qwerty', 'zxcv', 'jkl', 'wasd']

function isShort(text) {
  return text.length > 0 && text.length < 15
}

function isGibberish(text) {
  const lower = text.toLowerCase()
  if (/(.)\1{2,}/.test(lower)) return true
  if (KEYBOARD_RUNS.some((run) => lower.includes(run))) return true
  const words = lower.split(/\s+/)
  if (words.some((w) => w.length > 3 && !/[aeiouy]/.test(w))) return true
  if (words.length >= 3) {
    const counts = {}
    for (const w of words) {
      counts[w] = (counts[w] || 0) + 1
      if (counts[w] >= 3) return true
    }
  }
  return false
}

function isLowEffort(text) {
  return LOW_EFFORT_PHRASES.has(text.toLowerCase())
}

export function checkInputQuality(text) {
  const trimmed = (text || '').trim()
  if (!trimmed) return null
  if (isGibberish(trimmed)) return 'gibberish'
  if (isLowEffort(trimmed)) return 'low_effort'
  if (isShort(trimmed)) return 'short'
  return null
}
